import { render, staticRenderFns } from "./TabGridTable.vue?vue&type=template&id=be5ee058"
import script from "./TabGridTable.vue?vue&type=script&lang=js"
export * from "./TabGridTable.vue?vue&type=script&lang=js"
import style0 from "./TabGridTable.vue?vue&type=style&index=0&id=be5ee058&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports